import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// ...inputs ist jetzt typisiert als ein Array von ClassValues
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// 🛡️ SAFE STORAGE
// Wir definieren ein Interface für unseren Safe Storage, damit VS Code die Methoden kennt
interface SafeStorage {
  getItem: (key: string) => string | null;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
}

export const storage: SafeStorage = {
  getItem: (key: string) => {
    try {
      if (typeof window !== "undefined") {
        return window.localStorage.getItem(key);
      }
    } catch (e) {
      console.warn(`[Storage] Zugriff verweigert auf '${key}':`, e);
    }
    return null;
  },

  setItem: (key: string, value: string) => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, value);
      }
    } catch (e) {
      console.warn(`[Storage] Speichern fehlgeschlagen für '${key}':`, e);
    }
  },

  removeItem: (key: string) => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.removeItem(key);
      }
    } catch (e) {
      console.warn(`[Storage] Löschen fehlgeschlagen für '${key}':`, e);
    }
  },
};
